import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { CallbackModal } from '../components/CallbackModal';
import { MapPin, Star, Scan, Languages, Calendar, MessageCircle, CheckCircle2, Plus, Minus, Sparkles, Smile, Palette } from 'lucide-react';
import { Link } from 'react-router-dom';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const TELEGRAM_URL = 'https://t.me/dentico_clinic';
function TelegramIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-4712" data-mp="1jkr4ojxucqgw">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-4713" data-mp="1ekd5lre7wqv0" />
    </svg>;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onToggle
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-gray-100 last:border-b-0" data-id="element-4714" data-mp="2u8pm3d1i0s5u">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-4 text-left focus:outline-none group" data-id="element-4715" data-mp="2u97q4vuekaob">
        <span className="text-lg font-medium text-gray-900 group-hover:text-forest-700 transition-colors" data-id="element-4716" data-mp="3475erkg6c9hg">
          {question}
        </span>
        <span className={`flex-shrink-0 ml-4 w-6 h-6 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-forest-600 text-white' : 'bg-stone-100 text-gray-400'}`} data-id="element-4717" data-mp="3890dqiamuas2">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-4718" data-mp="142t48iugmvfj" /> : <Plus className="w-4 h-4" data-id="element-4719" data-mp="1hwu4jh128qi0" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-4720" data-mp="1d52bmzufm8op">
        <p className="text-gray-600 leading-relaxed" data-id="element-4721" data-mp="1rw1kmbz6iz8t">{answer}</p>
      </div>
    </div>;
}
export function VeneersLondonRuPage() {
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  const faqs = [{
    q: 'Сколько стоят виниры в Лондоне?',
    a: 'Цена зависит от материала (керамика или композит), количества зубов и сложности работы. После консультации мы предлагаем детальный план лечения и смету.'
  }, {
    q: 'Нужно ли обтачивать зубы под виниры?',
    a: 'В большинстве случаев требуется минимальная подготовка эмали (0.3-0.5 мм), но объем зависит от клинической ситуации. Мы всегда выбираем максимально щадящий подход (minimally invasive).'
  }, {
    q: 'Сколько служат виниры?',
    a: 'Керамические виниры могут служить 10-15 лет и более при правильном уходе. Срок службы зависит от материала, прикуса и гигиены. На консультации мы объясняем, как продлить долговечность.'
  }, {
    q: 'Можно ли сделать естественный результат?',
    a: 'Да, это наша специализация. Мы подбираем форму, текстуру и цвет индивидуально, чтобы улыбка выглядела гармонично и натурально, а не искусственно.'
  }, {
    q: 'Какая разница между фарфоровыми и композитными винирами?',
    a: 'Фарфоровые (керамические) виниры прочнее, долговечнее и устойчивее к окрашиванию. Композитные виниры (bonding) доступнее по цене и часто устанавливаются за один визит, но требуют более частой полировки.'
  }, {
    q: 'Сколько визитов нужно для виниров?',
    a: 'Обычно 2-3 визита для керамических виниров: консультация, подготовка/оттиски, установка. Композитные виниры часто можно сделать за один визит.'
  }, {
    q: 'Можно ли получить консультацию на русском?',
    a: 'Да, в Dentico Clinic возможно общение на русском языке во время консультации и лечения.'
  }, {
    q: 'Где находится Dentico Clinic?',
    a: 'Angel / Islington, 360–364 City Road, London EC1V 2PY. 5 минут пешком от станции Angel.'
  }];
  // Schemas
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a
      }
    }))
  };
  const procedureSchema = {
    '@context': 'https://schema.org',
    '@type': 'MedicalProcedure',
    name: 'Dental Veneers',
    description: 'Cosmetic dental procedure to improve the appearance of teeth using veneers.',
    procedureType: 'http://schema.org/NoninvasiveProcedure',
    provider: {
      '@type': 'Dentist',
      name: 'Dentico Clinic',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '360-364 City Road',
        addressLocality: 'London',
        postalCode: 'EC1V 2PY',
        addressCountry: 'GB'
      }
    }
  };
  return <Layout data-id="element-4722" data-mp="3lcfncvc3nbzo">
      <CallbackModal isOpen={isCallbackOpen} onClose={() => setIsCallbackOpen(false)} data-id="element-4723" data-mp="3ldz4sp9hrt31" />

      {/* Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-4724" data-mp="3q9xnpxc1wiw2" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(procedureSchema)
    }} data-id="element-4725" data-mp="2xo4sq9wzy8ju" />

      {/* 1. HERO SECTION */}
      <section className="relative bg-[#F8F5F0] overflow-hidden" data-id="element-4726" data-mp="9rpjbk2pxeux">
        <div className="absolute inset-0 bg-[#EFE8DE] -skew-y-3 origin-top-left transform translate-y-20" data-id="element-4727" data-mp="9puye5rg5mqu" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-20 lg:pb-24 relative" data-id="element-4728" data-mp="4r1un51ypa3v">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-4729" data-mp="eio3iuqtux3g">
            <div className="space-y-6" data-id="element-4730" data-mp="ejhe66swq6qv">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#EFE8DE] text-[#2F4A3F] border border-[#D8C4A8] text-sm font-medium" data-id="element-4731" data-mp="3my7s3ggjzrc6">
                <span className="relative flex h-2 w-2" data-id="element-4732" data-mp="3i18zj2cjfsg3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-forest-600 opacity-75" data-id="element-4733" data-mp="3vzfr60qw8w7b"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-forest-700" data-id="element-4734" data-mp="3qyjdivgqpvop"></span>
                </span>
                Эстетическая стоматология
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2B2D2F] leading-tight tracking-tight" data-id="element-4735" data-mp="168u1eq7f8nzp">
                Виниры в Лондоне –{' '}
                <span className="text-forest-700" data-id="element-4736" data-mp="1ishiu1hj3wms">Dentico Clinic</span>
                <br data-id="element-4737" data-mp="1itsj3rbrmm95" />
                <span className="text-2xl sm:text-3xl font-medium text-stone-500 mt-2 block" data-id="element-4738" data-mp="14sojxivuma3q">
                  (Angel, Islington)
                </span>
              </h1>

              <p className="text-lg text-gray-600 max-w-lg leading-relaxed" data-id="element-4739" data-mp="19s1givciuvji">
                Создайте идеальную улыбку с помощью керамических виниров или
                композитного бондинга. Естественный результат, минимальное
                вмешательство, консультация на русском.
              </p>

              {/* Trust Badges */}
              <div className="flex flex-wrap gap-3 text-sm font-medium text-[#2F4A3F]" data-id="element-4740" data-mp="1sqdseoutijis">
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-4741" data-mp="2gg84333ei21g">
                  <Star className="w-4 h-4 text-yellow-400 fill-current" data-id="element-4742" data-mp="2l782kcs64s62" />
                  Smile Makeover
                </div>
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-4743" data-mp="l69v6lmxzrcn">
                  <MapPin className="w-4 h-4 text-[#2F4A3F]" data-id="element-4744" data-mp="bevlxm56vd6b" />
                  Angel, EC1V
                </div>
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-4745" data-mp="7dk6g9g148bu">
                  <Languages className="w-4 h-4 text-[#2F4A3F]" data-id="element-4746" data-mp="142i17rns4690" />
                  Русский язык
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 pt-4" data-id="element-4747" data-mp="z2dg1obxencg">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-4748" data-mp="v1jsiw2ebak3">
                  <Button size="lg" className="w-full gap-2 !opacity-100 !bg-[#2F4A3F] !text-white !border !border-[#2F4A3F] hover:!bg-[#3A5A4D]" data-id="element-4749" data-mp="3ftvi1hladrz8">
                    <Calendar className="w-5 h-5" data-id="element-4750" data-mp="1qdjf11ujjyl0" />
                    Записаться на консультацию
                  </Button>
                </a>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-4751" data-mp="1zcwp9wqhor6s">
                  <Button size="lg" className="w-full gap-2 !opacity-100 !bg-[#EFE8DE] !text-[#2F4A3F] !border !border-[#D8C4A8] hover:!bg-[#2F4A3F] hover:!text-white" data-id="element-4752" data-mp="292pzouewb09g">
                    <MessageCircle className="w-5 h-5" data-id="element-4753" data-mp="2j1ozdnhonlkb" />
                    WhatsApp
                  </Button>
                </a>
              </div>
            </div>

            <div className="relative" data-id="element-4754" data-mp="omw4jqomiytf">
              <div className="absolute inset-0 bg-[#D8C4A8] rounded-3xl transform rotate-3 blur-sm opacity-30" data-id="element-4755" data-mp="onxsgvqqnfsk"></div>
              <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1200&q=80" alt="Виниры и эстетическая стоматология - Dentico Clinic" className="relative rounded-3xl shadow-2xl object-cover h-[300px] sm:h-[400px] lg:h-[500px] w-full" data-id="element-4756" data-mp="sohqe1j4ynfr" />
            </div>
          </div>
        </div>
      </section>

      {/* 2. WHAT ARE VENEERS */}
      <section className="py-16 bg-white" data-id="element-4757" data-mp="1str9or6owkdg">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4758" data-mp="1sszl40bifmwo">
          <div className="text-center mb-10" data-id="element-4759" data-mp="1wuum13pj3y9x">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-4760" data-mp="1wtt72o5e6rmx">
              Что такое виниры?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-4761" data-mp="21o5utadwip4h">
              Виниры — это ультратонкие керамические накладки, которые
              фиксируются на переднюю поверхность зубов для улучшения их формы,
              цвета и положения. Это идеальное решение для коррекции сколов,
              промежутков между зубами (диастем), изменения цвета эмали, который
              не поддается отбеливанию, или выравнивания незначительных
              неровностей.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mt-4" data-id="element-4762" data-mp="3w0zyoewuvwpr">
              Современные виниры выглядят абсолютно естественно благодаря
              способности пропускать свет так же, как натуральная эмаль. В
              Dentico Clinic мы используем цифровые технологии для моделирования
              вашей будущей улыбки еще до начала лечения.
            </p>
          </div>
        </div>
      </section>

      {/* 3. PROCESS */}
      <section className="py-16 bg-gray-50" data-id="element-4763" data-mp="dw6g27sq79qa">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4764" data-mp="dv3nlvfr8z89">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-4765" data-mp="8yd9verfafq0">
            Путь к новой улыбке
          </h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-4766" data-mp="16ek4xhw33ld8">
            {[{
            step: '01',
            title: 'Консультация',
            desc: 'Обсуждение пожеланий, фотопротокол и цифровое моделирование улыбки.'
          }, {
            step: '02',
            title: 'Планирование',
            desc: 'Примерка макета (mock-up), чтобы вы увидели результат до начала работ.'
          }, {
            step: '03',
            title: 'Подготовка',
            desc: 'Минимальная обработка зубов и снятие точных оттисков или сканирование.'
          }, {
            step: '04',
            title: 'Фиксация',
            desc: 'Установка готовых керамических виниров и финальная эстетика.'
          }].map((item, idx) => <Card key={idx} className="p-6 relative overflow-hidden" data-id="element-4767" data-mp="283qshjkswoho" data-mpi={idx}>
                <div className="text-6xl font-bold text-[#EFE8DE] absolute -top-4 -right-4 select-none" data-id="element-4768" data-mp="1e2n3aefhig2">
                  {item.step}
                </div>
                <div className="relative z-10" data-id="element-4769" data-mp="6cnhgt7017wl">
                  <h3 className="text-xl font-bold text-[#2B2D2F] mb-3" data-id="element-4770" data-mp="1quy7n5qwvy7s">
                    {item.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-4771" data-mp="1lx65zk0gsxqe">{item.desc}</p>
                </div>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 4. TYPES */}
      <section className="py-16 bg-white" data-id="element-4772" data-mp="1vu13q0owyu3m">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4773" data-mp="1vszt1xbt89mf">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-4774" data-mp="29ko3lw6euq1a">
            <div data-id="element-4775" data-mp="24muxf353xw10">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-4776" data-mp="24ne5ls4yh61u">
                Виды эстетической реставрации
              </h2>
              <div className="space-y-6" data-id="element-4777" data-mp="2jjddp2s2f66z">
                <div className="flex gap-4" data-id="element-4778" data-mp="2el21ileasjll">
                  <div className="p-3 bg-[#F8F5F0] border border-[#D8C4A8] rounded-lg text-[#2F4A3F] h-fit" data-id="element-4779" data-mp="2em3ljfdakgfg">
                    <Sparkles className="w-6 h-6" data-id="element-4780" data-mp="p649nqiagcw4" />
                  </div>
                  <div data-id="element-4781" data-mp="k7sz1dk65ycu">
                    <h3 className="text-xl font-bold text-[#2B2D2F] mb-2" data-id="element-4782" data-mp="k8lyrukpnnlh">
                      Керамические виниры
                    </h3>
                    <p className="text-gray-600" data-id="element-4783" data-mp="3ce1pnuatudhh">
                      Изготавливаются в лаборатории из высокопрочной керамики.
                      Максимально эстетичные, долговечные и устойчивые к
                      изменению цвета.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-4784" data-mp="2op8z6dcz4xu9">
                  <div className="p-3 bg-[#F8F5F0] border border-[#D8C4A8] rounded-lg text-[#2F4A3F] h-fit" data-id="element-4785" data-mp="2oqk4ihm2idnh">
                    <Palette className="w-6 h-6" data-id="element-4786" data-mp="2tlpo39rzzg8e" />
                  </div>
                  <div data-id="element-4787" data-mp="2xom2eoai8q6j">
                    <h3 className="text-xl font-bold text-[#2B2D2F] mb-2" data-id="element-4788" data-mp="2xnaxgl5bpcdu">
                      Композитный бондинг
                    </h3>
                    <p className="text-gray-600" data-id="element-4789" data-mp="25yrbin700sfr">
                      Художественная реставрация композитным материалом прямо в
                      кресле. Быстрее и доступнее, но требует периодической
                      полировки.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-4790" data-mp="1xgz3z4sw15i2">
                  <div className="p-3 bg-[#F8F5F0] border border-[#D8C4A8] rounded-lg text-[#2F4A3F] h-fit" data-id="element-4791" data-mp="1xf4fjgieqv98">
                    <Smile className="w-6 h-6" data-id="element-4792" data-mp="1thghw5pbyodn" />
                  </div>
                  <div data-id="element-4793" data-mp="1og0u45vrq3rk">
                    <h3 className="text-xl font-bold text-[#2B2D2F] mb-2" data-id="element-4794" data-mp="1oivg41ufjwn3">
                      Smile Makeover
                    </h3>
                    <p className="text-gray-600" data-id="element-4795" data-mp="1eqhct4npehyt">
                      Комплексное преображение улыбки, которое может сочетать
                      виниры, коронки и отбеливание для идеального результата.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl" data-id="element-4796" data-mp="10pwsg4254e37">
              <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1200&q=80" alt="Типы виниров" className="absolute inset-0 w-full h-full object-cover" data-id="element-4797" data-mp="vrlizufrc5li" />
            </div>
          </div>
        </div>
      </section>

      {/* 5. BENEFITS */}
      <section className="py-16 bg-[#EFE8DE]" data-id="element-4798" data-mp="c7we7jwhctp2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4799" data-mp="h4mv29g3ztbj">
          <div className="text-center mb-12" data-id="element-4800" data-mp="h6zllazxnc07">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-4801" data-mp="14vs9qlabcfk9">
              Почему стоит выбрать Dentico Clinic
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-4802" data-mp="19voeimqu4b0v">
            {[{
            title: 'Естественный вид',
            desc: 'Мы создаем улыбки, которые выглядят натурально, а не искусственно.'
          }, {
            title: 'Минимальное вмешательство',
            desc: 'Сохраняем максимум здоровых тканей зуба благодаря современным техникам.'
          }, {
            title: 'Русский язык',
            desc: 'Легкое общение и полное понимание ваших пожеланий.'
          }, {
            title: 'Удобная локация',
            desc: 'Клиника в центре Лондона (Angel), легко добраться из любого района.'
          }].map((item, idx) => <Card key={idx} className="p-6 bg-white text-center" data-id="element-4803" data-mp="3i3jt3xpo6qsq" data-mpi={idx}>
                <div className="w-12 h-12 bg-[#F8F5F0] rounded-full flex items-center justify-center text-[#2F4A3F] mb-4 mx-auto border border-[#D8C4A8]" data-id="element-4804" data-mp="2ucnt4db28pae">
                  <CheckCircle2 className="w-6 h-6" data-id="element-4805" data-mp="33cko0wo1mkdw" />
                </div>
                <h3 className="text-lg font-bold text-[#2B2D2F] mb-2" data-id="element-4806" data-mp="33ag8fhgs7wxs">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-4807" data-mp="imbpoyi1k252">{item.desc}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 6. FAQ */}
      <section className="py-16 bg-white" data-id="element-4808" data-mp="ek6xm478rdkj">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4809" data-mp="283pf2ev964gb">
          <div className="text-center mb-10" data-id="element-4810" data-mp="285a79xu3hbb0">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-4811" data-mp="2d20q2sxaal04">
              Частые вопросы о винирах
            </h2>
          </div>
          <div className="space-y-2" data-id="element-4812" data-mp="2i02abh6g4qd6">
            {faqs.map((faq, idx) => <AccordionItem key={idx} question={faq.q} answer={faq.a} isOpen={openFaqIndex === idx} onToggle={() => toggleFaq(idx)} data-id="element-4813" data-mp="2mtethbscw4yj" data-mpi={idx} />)}
          </div>
        </div>
      </section>

      {/* 7. INTERNAL LINKS */}
      <section className="py-12 bg-gray-50 border-t border-gray-100" data-id="element-4814" data-mp="30snyrgf0xenq">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4815" data-mp="35rhbh6mhl1mu">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-4816" data-mp="16e3kpml7khdb">
            Смотрите также
          </h2>
          <div className="flex flex-wrap gap-4" data-id="element-4817" data-mp="1bcwxfcso84cf">
            <Link to="/ru/russkij-stomatolog-london" data-id="element-4818" data-mp="1bdq6wlj0l7y9">
              <Button variant="outline" size="sm" data-id="element-4819" data-mp="3onzqzw27nuzv">
                Русскоязычный стоматолог
              </Button>
            </Link>
            <Link to="/ru/services/smile-makeover" data-id="element-4820" data-mp="3jvy83rajf60v">
              <Button variant="outline" size="sm" data-id="element-4821" data-mp="3fv5zn09hp55n">
                Smile Makeover
              </Button>
            </Link>
            <Link to="/ru/services/whitening" data-id="element-4822" data-mp="3awungivq2ik9">
              <Button variant="outline" size="sm" data-id="element-4823" data-mp="3atyoqsc1vpur">
                Отбеливание
              </Button>
            </Link>
            <Link to="/ru/prices" data-id="element-4824" data-mp="7fcrb8pbazzo">
              <Button variant="outline" size="sm" data-id="element-4825" data-mp="7f2x18x8i6o6">
                Цены
              </Button>
            </Link>
            <Link to="/ru/contact" data-id="element-4826" data-mp="2eyhpm82bhzj">
              <Button variant="outline" size="sm" data-id="element-4827" data-mp="2i2uh7zlfm1t">
                Контакты
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* 8. CTA */}
      <section className="py-16 bg-forest-900" data-id="element-4828" data-mp="2n7s9bl0ar7ui">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-4829" data-mp="2i6upl3zn25qw">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-4830" data-mp="2i9gz3963avbr">
            Мечтаете об идеальной улыбке?
          </h2>
          <p className="text-xl text-ivory/80 mb-8 max-w-2xl mx-auto" data-id="element-4831" data-mp="2p42gqlf5f90c">
            Запишитесь на консультацию и узнайте, как виниры могут изменить вашу
            жизнь.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-4832" data-mp="2f5mtwun5mlwn">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-4833" data-mp="2f3iepgjt20h2">
              <Button variant="primary" surface="dark" size="lg" className="w-full gap-2" data-id="element-4834" data-mp="37vlikoxfsh0s">
                <Calendar className="w-5 h-5" data-id="element-4835" data-mp="2xww1uzha12m4" />
                Записаться онлайн
              </Button>
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-4836" data-mp="1rgtsiinrjlun">
              <Button variant="whatsapp" surface="dark" size="lg" className="w-full gap-2" data-id="element-4837" data-mp="1zeyzw3lxs11">
                <MessageCircle className="w-5 h-5" data-id="element-4838" data-mp="bx2wgtslldmw" />
                WhatsApp
              </Button>
            </a>
          </div>
        </div>
      </section>
    </Layout>;
}